export enum AccountViewType {
    INFO,
    SUBSCRIPTIONS,
    PURCHASES,
    INTEGRATIONS
}
